import { useParams } from 'react-router-dom'
import { useTenants } from './useTenants'

const useTenant = () => {
  const { tenantUrlSlug } = useParams()
  const { tenants } = useTenants(!!tenantUrlSlug)

  const tenant = tenantUrlSlug
    ? tenants?.find(
        (it) => it.urlSlug.toLowerCase() === tenantUrlSlug?.toLowerCase()
      )
    : undefined

  return { tenant }
}

export { useTenant }
